import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting,
  GiftTaxEntity,
  Persoon,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {
  BokkzAlgDataService,
  BokkzSbDataService,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {Subscription} from "rxjs";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-aangever',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  templateUrl: './aangever.component.html',
  styleUrl: './aangever.component.css'
})
export class AangeverComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private giftTaxEntitySubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public persoonFg = {} as FormGroup;
  public beconNummer: string | undefined;
  public focusedElementId: string | null = null;

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    private fb: FormBuilder) {
    this.persoonFg = this.fb.group<Persoon>({
      roepnaam: null as unknown as string,
      voorletters: null as unknown as string,
      tussenvoegsels: null as unknown as string,
      achternaam: null as unknown as string,
      bsn: null as unknown as string,
      geboortedatum: null as unknown as Date,
      overlijdensdatum: null as unknown as Date,
      landCodeNationaliteit: null as unknown as string,
    })
  }

  ngOnInit(): void {
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((giftTaxEntity) => {
      this.giftTaxEntity = giftTaxEntity;
      const aangifte = giftTaxEntity.aangifte
      if (aangifte) {
        this.sbAangifte = aangifte;
        this.persoonFg.patchValue(aangifte.begiftigde, {emitEvent: false})
      }
    })
  }

  ngOnDestroy(): void {
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.persoonFg.updateValueAndValidity();
    setTimeout(() => {
      this.giftTaxEntity.aangifte = {
        ...this.sbAangifte,
        begiftigde: {
          ...this.sbAangifte.begiftigde,
          roepnaam: this.persoonFg.value.roepnaam,
          voorletters: this.persoonFg.value.voorletters,
          tussenvoegsel: this.persoonFg.value.tussenvoegsels,
          achternaam: this.persoonFg.value.achternaam,
          bsn: this.persoonFg.value.bsn,
          geboortedatum: this.persoonFg.value.geboortedatum,
          overlijdensdatum: this.persoonFg.value.overlijdensdatum,
          landCodeNationaliteit: this.persoonFg.value.landCodeNationaliteit,
        },
        bovenmatigeErfrechtelijkeRenteBijLevenUitbetaald: false,
        verblijvingBedingInMaatschapsContract: false,
        vruchtgebruikRentelozeLening: false,
        andereBijzondereSituatieVanToepassing: false,
      } as AangifteSchenkbelasting;
      this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
    }, 100)
  }
}
